import React from 'react'
import MainBanner from '../Generator/MainBanner';
import EventSchedulesThree from '../Generator/EventSchedulesThree';
import Footer from '../Common/Footer';
 
class ScheduleThree extends React.Component {
    render(){
        return (
            <React.Fragment>
                <MainBanner />
                <EventSchedulesThree />
                <Footer />
            </React.Fragment>
        );
    }
}
 
export default ScheduleThree;